// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ExpenseConciliationSummaryResponseDados {
period_status: number
amount: number
count: number
value_in_decimal: number
}

export type Payroll_ExpenseConciliationSummaryResponse = ApiResponse<Payroll_ExpenseConciliationSummaryResponseDados>;

registerResponseContract('Payroll_ExpenseConciliationSummaryResponse', {
  period_status:    { type: 'number',  required: true },
  amount:           { type: 'number',  required: true },
  count:            { type: 'number',  required: true },
  value_in_decimal: { type: 'number',  required: true },
})
